import { render, staticRenderFns } from "./RentOrBuy.vue?vue&type=template&id=3772db5b&scoped=true&"
import script from "./RentOrBuy.vue?vue&type=script&lang=js&"
export * from "./RentOrBuy.vue?vue&type=script&lang=js&"
import style0 from "./RentOrBuy.vue?vue&type=style&index=0&id=3772db5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3772db5b",
  null
  
)

export default component.exports